// @ts-nocheck

import { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Spacer } from '@zillow/constellation';
import { Text } from '@zillow/constellation-10';
import { LoadingHeading } from '@zg-rentals/loading-components';

import SpinnerContainer from '../../components/SpinnerContainer';

import { StyledConnectedCard, StyledHeadingWrapper } from './StyledComponents';

const ConnectedModuleCard = ({
  borderRadius,
  children,
  className = '',
  ctaComponent,
  ctaFontColor,
  ctaFontType,
  enableHover: pEnableHover,
  includeBorderTop = false,
  isLoading,
  justifyHeadingContent,
  leftComponent,
  mediaQuery,
  minHeightXL,
  spinnerHeight: height,

  title,
  titleGrow,
}) => {
  const [enableHover, setEnableHover] = useState(false);

  const renderSpinner = () => <SpinnerContainer height={height} />;

  const handleMouseOver = () => {
    if (pEnableHover) {
      setEnableHover(true);
    }
  };

  const handleMouseOut = () => {
    if (pEnableHover) {
      setEnableHover(false);
    }
  };

  return (
    <StyledConnectedCard
      data-testid="ConnectedCard"
      className={cx('ConnectedCard', className)}
      borderRadius={borderRadius}
      includeBorderTop={includeBorderTop}
      minHeightXL={minHeightXL}
      mediaQuery={mediaQuery}
      enableHover={enableHover}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
    >
      {(leftComponent || title || ctaComponent) && (
        <StyledHeadingWrapper className="ConnectedCard-TitleWrapper" justifyHeadingContent={justifyHeadingContent}>
          {leftComponent && <div data-testid="ConnectedCard-Heading">{leftComponent}</div>}

          {title && (
            <LoadingHeading
              data-testid="ConnectedCard-Heading"
              level={2}
              isLoading={isLoading}
              loadingWidth="40%"
              css={{
                fontSize: { base: 'body', lg: 'heading-xs' },
                lineHeight: { base: 'body', lg: 'heading-xs' },
                flexGrow: titleGrow,
                marginRight: '400',
                color: enableHover ? 'text.action.hero.default' : 'text.neutral',
              }}
            >
              {title}
            </LoadingHeading>
          )}

          <Spacer marginBottom={{ default: 'sm', lg: 0 }} />

          {ctaComponent && (
            <Text
              className="ConnectedCard-CTA"
              css={{
                textStyle: ctaFontType,
                color: enableHover ? 'text.action.hero.default' : ctaFontColor,
                _hover: { color: 'text.action.hero.default' },
              }}
            >
              {ctaComponent}
            </Text>
          )}
        </StyledHeadingWrapper>
      )}
      {children}
    </StyledConnectedCard>
  );
};

ConnectedModuleCard.propTypes = {
  borderRadius: PropTypes.string,
  ctaComponent: PropTypes.node,
  ctaFontColor: PropTypes.string,
  ctaFontType: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  enableHover: PropTypes.bool,
  fontType: PropTypes.string,
  isLoading: PropTypes.bool,
  justifyHeadingContent: PropTypes.string,
  leftComponent: PropTypes.node,
  mediaQuery: PropTypes.object,
  minHeightXL: PropTypes.string,
  spinnerHeight: PropTypes.string,

  title: PropTypes.string,
  titleGrow: PropTypes.number,
};

ConnectedModuleCard.defaultProps = {
  borderRadius: '4px',
  ctaComponent: null,
  ctaFontColor: 'text.neutral',
  ctaFontType: { base: 'body-sm', lg: 'body' },
  enableHover: false,
  isLoading: false,
  justifyHeadingContent: 'flex-start',
  leftComponent: null,
  mediaQuery: null,
  minHeightXL: null,
  spinnerHeight: '200px',
  title: null,
  titleGrow: 1,
};

export default ConnectedModuleCard;
